export default __webpack_public_path__ + "static/media/blogPropsTwitterLogo.3fd11011.PNG";